module.exports = __webpack_public_path__ + "img/philosophy-of-science-cover.8c667008.jpg";